import { render, staticRenderFns } from "./wechattab.vue?vue&type=template&id=71ecad2e&scoped=true"
import script from "./wechattab.vue?vue&type=script&lang=js"
export * from "./wechattab.vue?vue&type=script&lang=js"
import style0 from "./wechattab.vue?vue&type=style&index=0&id=71ecad2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ecad2e",
  null
  
)

export default component.exports